export default __webpack_public_path__ + "static/media/72.7117ca72.png";